'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('userSvc', userSvc);

  userSvc.$inject = ['httpSvc', '$q', 'providerSvc', 'NotifyingSvc', 'msAuth', '$sessionStorage'];

  function userSvc(httpSvc, $q, providerSvc, NotifyingSvc, msAuth, $sessionStorage) {
    var service = this;
    var accountDeleteUrl = '/apiproxy/user/request/accountdelete';

    function save(user) {
      var userUpdateModel = {
        alias: user.alias,
        emailAddress: user.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        dateOfBirth: user.dateOfBirth,
        gender: user.gender,
        sexAtBirth: user.sexAtBirth,
        language: user.language,
        optedIntoCoachingEmails: user.optedIntoCoachingEmails,
        optedIntoAssessmentEmails: user.optedIntoAssessmentEmails,
        optedIntoConsumerEmails: user.optedIntoConsumerEmails,
        sendAuthCode: user.sendAuthCode,
        wellnessProgram: user.wellnessProgram,
        wellnessCategory: user.wellnessCategory
      };
      return httpSvc.post('/apiproxy/user/update', userUpdateModel);
    }

    /**
     * Request a multi-factor auth code communication
     */
    service.sendAuthCode = function () {
      // this would be a great place to get back information about
      // the user's multi-factor setup for UX and messaging purposes
      return httpSvc.post('/apiproxy/user/multifactor/send', null);
    };

    /**
     * Change the user's password to the value specified.
     * @param password
     */
    function changePassword(password) {
      return httpSvc.post('/apiproxy/user/password', password);
    }

    service.changePassword = changePassword;

    /**
     * Save the passed in user by calling the api save service. Saved user will be returned in optional
     * success callback function. Error response will be returned if optional errorCallback is specified.
     * @param userIn
     * @param successCallback Optional callback function for successful save
     * @param errorCallback Option callback function for error during save
     */
    service.saveUser = function (userIn, successCallback, errorCallback, isSso) {
      var _successCB = successCallback || angular.noop;
      var _errorCB = errorCallback || angular.noop;
      return save(userIn).then(function (response) {
        var _user = response;
        if (!_user) {
          _errorCB(response);
          return;
        } else {
          //refresh the sessionStorage cache for the user
          $sessionStorage.user = _user;
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_UPDATED, {
            user: _user
          });
          if (userIn.password) {
            changePassword(userIn.password).then(function () {
              // Client-side logout on success for all NON-SSO callers per
              // MY-814 : WHS-52637753 - https://www.owasp.org/index.php/Session_Management_Cheat_Sheet#Renew_the_Session_ID_After_Any_Privilege_Level_Change
              if (!isSso) {
                msAuth.logout();
              }
            }, _errorCB);
          }
        }
        _successCB(response);
      }, function (response) {
        _errorCB(response);
      });
    };

    service.savePreferences = function (preferences, successCallback, errorCallback) {
      var _successCB = successCallback || angular.noop;
      var _errorCB = errorCallback || angular.noop;
      //in resume scenarios this may be the first place we land, so we need
      //to fetch the user prior to doing our preferences save
      var deferred = $q.defer();
      if (!$sessionStorage.user) {
        service.getUser().then(function () {
          deferred.resolve();
        });
      } else {
        deferred.resolve();
      }
      return deferred.promise.then(function () {
        if ($sessionStorage.user && $sessionStorage.user.userPreferences) {
          $sessionStorage.user.userPreferences = angular.extend($sessionStorage.user.userPreferences, preferences);
        }
        return httpSvc.post('/apiproxy/user/preferences', $sessionStorage.user.userPreferences).then(function (response) {
          $sessionStorage.user = response;
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_UPDATED, {
            user: response
          });
          _successCB(response);
        }, function (response) {
          _errorCB(response);
        });
      });
    };

    /**
     * Saves activity_tag preferences. This associates a user with activity tags
     * @param  {Array} toAdd    A list of tags to add
     * @param  {Array} toRemove A list of tags to remove
     */
    service.saveTagPreferences = function (toAdd, toRemove) {
      // if no preferences passed, they may be removing only
      if (!toAdd) {
        toAdd = [];
      }
      if (!toRemove) {
        toRemove = [];
      }
      // if single-item params, convert to an array
      if (!_.isArray(toAdd)) {
        toAdd = [toAdd];
      }
      if (!_.isArray(toRemove)) {
        toRemove = [toRemove];
      }
      var toAddQP = '';
      var toRemoveQP = '';
      if (toAdd.length > 0) {
        toAddQP = 'add=' + toAdd.join('&add=');
      }
      if (toRemove.length > 0) {
        toRemoveQP = 'remove=' + toRemove.join('&remove=');
        toRemoveQP = (toAdd.length > 0 ? '&' : '') + toRemoveQP;
      }
      return httpSvc.post('/apiproxy/user/metadata/tags?' + toAddQP + toRemoveQP, null).then(function () {
        $sessionStorage.user = null;
      });
    };

    service.getUsersCoachingProfile = function () {
      return httpSvc.get('/apiproxy/coaching/profile').then(function (resp) {
        var coachingElection = !_.isUndefined(resp.coachingElection) ? resp.coachingElection : null;
        if (coachingElection === 'INELIGIBLE') {
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_COACHING_ENABLEMENT_UPDATED, {
            status: false
          });
        }
        return resp;
      });
    };

    service.coachingOptIn = function () {
      return httpSvc.post('/apiproxy/coaching/profile/reelection', {}).then(function () {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_COACHING_ENABLEMENT_UPDATED, {
          status: true
        });
      });
    };

    service.coachingOptOut = function () {
      var OPTED_OUT = 'OPTED_OUT';
      return httpSvc.post('/apiproxy/coaching/profile/coachingelection', {
        coachingElection: OPTED_OUT
      }).then(function () {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_COACHING_ENABLEMENT_UPDATED, {
          status: false
        });
      });
    };

    service.update = function (info) {
      return httpSvc.post('/apiproxy/user/update', info).then(function (resp) {
        //refresh the sessionStorage cache for the user
        $sessionStorage.user = resp;
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_UPDATED, {
          user: resp.data
        });
        return resp;
      });
    };

    service.getUser = function (forceRefresh) {
      //bail if the token has expired or we're not logged in
      if (!msAuth.isLoggedIn()) {
        //calling logout explicitly kills sessionStorage in the event of a timeout
        msAuth.logout();
        return $q.reject();
      }
      // If $sessionStorage.user exists, it could either be an unresolve Promise, or the real user object.
      // In case it is a Promise, we wait for it to finish, then set the Provider, then return the user object.
      if (!forceRefresh && $sessionStorage.user && !_.isEmpty($sessionStorage.user)) {
        return $q.when($sessionStorage.user).then(function () {
          return _setUserProvider($sessionStorage.user).then(function () {
            return $sessionStorage.user;
          });
        });
      }
      // If $sessionStorage.user does not exist, we make a new request, and store that to $sessionStorage.user
      // and return it.
      return httpSvc.get('/apiproxy/user').then(function (resp) {
        $sessionStorage.user = resp;
        return _setUserProvider(resp).then(function () {
          return $sessionStorage.user;
        });
      }, function (err) {
        $sessionStorage.user = undefined;
        return $q.reject(err);
      });
    };

    function _setUserProvider(userPromise) {
      return $q.when(userPromise).then(function (user) {
        return providerSvc.setProvider({
          organization: user.organization.shortName,
          accessCode: user.accessCode.accessCode,
          group: user.accessCodeGroup ? user.accessCodeGroup.shortName : null,
          preferences: user.providerPreferences
        });
      });
    }

    service.logout = function () {
      return httpSvc.post('/apiproxy/user/logout', {});
    };

    service.getAccountDeletionRequest = function () {
      return httpSvc.get(accountDeleteUrl);
    };

    service.requestAccountDeletion = function (reason) {
      return httpSvc.post(accountDeleteUrl, reason);
    };

    service.cancelAccountDeletion = function () {
      return httpSvc.delete(accountDeleteUrl);
    };
  }
})();